import { useConfigurationContext } from "../root/ConfigurationContext";

// One color per configured event type, in the order of the Settings list.
const EVENT_TYPE_PALETTE = [
  "#2563eb",
  "#db2777",
  "#16a34a",
  "#ea580c",
  "#7c3aed",
  "#0891b2",
  "#ca8a04",
  "#dc2626",
  "#4f46e5",
  "#059669",
];
const UNKNOWN_TYPE_COLOR = "#64748b";

/** Label and color of an event type, as configured in the Settings. */
export const useEventTypeLookup = () => {
  const { eventTypes } = useConfigurationContext();
  return (type?: string | null) => {
    const index = eventTypes.findIndex((item) => item.value === type);
    return index === -1
      ? { value: type ?? "", label: type ?? "", color: UNKNOWN_TYPE_COLOR }
      : {
          value: eventTypes[index].value,
          label: eventTypes[index].label,
          color: EVENT_TYPE_PALETTE[index % EVENT_TYPE_PALETTE.length],
        };
  };
};
